var _rect, _path, _circle, _circle2, _circle3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 200 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 150,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H188C194.627 0 200 5.37258 200 12V26H0V12Z",
    fill: "#AAAAAA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 13,
    r: 4,
    fill: "#FF847C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 13,
    r: 4,
    fill: "#FAD17B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 13,
    r: 4,
    fill: "#97E17E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.8895 85.0605C96.0688 84.641 96.0139 84.1438 95.6913 83.8212L66.6875 54.8174C65.9577 54.0877 64.7351 54.8073 65.019 55.7995L73.756 86.3437C76.9482 98.6431 90.274 117.179 111.389 112.955C111.722 112.889 112.075 112.988 112.316 113.228L124.161 125.074C124.552 125.464 125.185 125.464 125.575 125.074L139.075 111.574C139.465 111.184 139.465 110.55 139.075 110.16L127.229 98.3136C126.988 98.0731 126.889 97.7201 126.956 97.3865C131.178 76.2732 112.643 62.9481 100.343 59.756L69.8013 51.0195C68.8091 50.7357 68.0895 51.9583 68.8192 52.688L97.8217 81.6905C98.1443 82.0132 98.6415 82.068 99.0611 81.8887C101.258 80.9497 103.9 81.3767 105.693 83.1696C108.046 85.5229 108.046 89.3384 105.693 91.6918C103.339 94.0451 99.5239 94.0451 97.1705 91.6918C95.3777 89.899 94.9507 87.2576 95.8895 85.0605Z",
    fill: "#547AFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesign);
export default __webpack_public_path__ + "static/media/icon_design.07ed1b8b1400d50e5531ac7c810a176d.svg";
export { ForwardRef as ReactComponent };